import React, { useState, useEffect } from "react";
import '../css/kabar.css';
import data from '../data/small-news.json';
import jurnal from '../data/jurnal.json';
import Dropdown from "react-bootstrap/Dropdown";

export default function Kabar() {
    const [jsonData, setJsonData] = useState([]);
    const [jsonJurnal, setJsonJurnal] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 425);

    useEffect(() => {
        setJsonData(data);
        setJsonJurnal(jurnal);
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 430);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <section className="kabar">
            <h1 className="title">Kabar terbaru kami</h1>
            <div className="option d-flex justify-content-between align-items-center">
                
            {isMobile ? (
                        <Dropdown className="dropdown-campaign">
                        <Dropdown.Toggle id="dropdown-basic" className="dropdown-campaign dropdown">
                          Kabar SMALAB
                        </Dropdown.Toggle>
            
                        <Dropdown.Menu>
                          <Dropdown.Item className="dropdown-campaign">Kabar SMALAB</Dropdown.Item>
                          <Dropdown.Item className="dropdown-campaign">Prestasi</Dropdown.Item>
                          <Dropdown.Item className="dropdown-campaign">Pengumuman</Dropdown.Item>
                          <Dropdown.Item className="dropdown-campaign">Artikel</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    ) : (
                <div className="bungkus-menu">
                    <a href="#" style={{ color: "#", fontWeight: "bold" }}className="kabar-smalab">Kabar SMALAB</a>
                    <a href="#" style={{ color: "black", textDecoration: "none" }}>Prestasi</a>
                    <a href="#" style={{ color: "black", textDecoration: "none" }}>Pengumuman</a>
                    <a href="#" style={{ color: "black", textDecoration: "none" }}>Artikel</a>
                </div>
                    )}

                <button className="f-lain btn cursor-pointer d-flex gap-2 align-items-center">
                    <p className="info my-auto">Informasi Lainnya</p>
                    <img src="../../assets/agenda/arrow-orange-right.svg" className="oren"></img>
                </button>

            </div>
            <div className="artikel">
                <div className="cover-duta">
                    <div className="frame">
                        <img src="../../assets/kabar/duta.svg" className="duta" alt="duta"></img>
                    </div>

                    <p className="smalab">Kabar SMALAB • 19 Feb, 2014</p>
                    <h1 className="erat">
                        Eratkan Persahabatan, Duta PPK SMA LAB UM Kunjungi Putra-Putri Mitreka Satata
                    </h1>
                </div>
                <div className="data-news">
                    {jsonData.map((item, index) => (
                        <a key={index}>
                            <div className="bungkus-news">
                                <div className="news-wrapper">
                                    <img src={item.img} className="news" style={{ position: "relative" }} />
                                    <img src="../../assets/kabar/arrow-up.svg" className="arrow-img" />
                                </div>
                                <div>
                                    <p className="smalab bum" style={{ marginTop: "0px" }}>Kabar SMALAB • {item.tgl}</p>
                                    <h1 className="small">{item.detail}</h1>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>

            {/* JURNALISTIK */}
            <div className="jurnal">
                <h1>Jurnalistik</h1>
                <div className="data-jurnal">
                    {jsonJurnal.map((item, index) => (
                        <div key={index} className="konten-jurnal">
                            <a>
                                <img src={item.img} className="img-jurnal" />
                                <p className="jan">05 Jan, 2024</p>
                                <h1 className="detail-jurnal">
                                    {item.detail}
                                </h1>
                            </a>
                        </div>
                    ))}
                </div>
                <button className="lihat btn cursor-pointer d-flex align-items-center gap-2 h-auto w-auto">
                    <p className="lihat my-auto">Lihat Semua</p>
                    <img src="../../assets/kabar/arrow-right2.svg" className="kanan"></img>
                </button>

            </div>


        </section >
    )
}